import { BP42Action } from '@r1-frontend/bp42/constants/actions';

import { IAction } from '@r1-frontend/shared/types/Redux';

const closePopup = (): IAction<BP42Action.ClosePopup, null> => ({
    type: BP42Action.ClosePopup,
    payload: null,
});

export default closePopup;
